import React from "react";
import { MdFilterListOff } from "react-icons/md";

const SosialyFilters = ({ filters, onFilterChange, onResetFilters, membres = [], moisOptions = [] }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onFilterChange({ [name]: value === "" ? null : value });
  };

  // Générer une liste d'années (de l'année actuelle - 5 à l'année actuelle + 5)
  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear - 5; year <= currentYear + 5; year++) {
      years.push(year.toString());
    }
    return years;
  };

  const years = generateYears();

  return (
    <div className="mb-6 rounded-lg border border-gray-200 bg-gray-50 p-4">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-sm font-medium text-gray-700">Filtres avancés</h3>
        <button
          onClick={onResetFilters}
          className="flex items-center gap-1 text-sm text-gray-600 hover:text-gray-900"
        >
          <MdFilterListOff className="h-4 w-4" />
          <span>Réinitialiser</span>
        </button>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
        <div>
          <label htmlFor="mois" className="block text-xs font-medium text-gray-700">
            Mois
          </label>
          <select
            id="mois"
            name="mois"
            value={filters.mois || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-green-500 focus:outline-none focus:ring-green-500"
          >
            <option value="">Tous les mois</option>
            {moisOptions.map(mois => (
              <option key={mois} value={mois}>{mois}</option>
            ))}
          </select>
        </div>
        
        <div>
          <label htmlFor="annee" className="block text-xs font-medium text-gray-700">
            Année
          </label>
          <select
            id="annee"
            name="annee"
            value={filters.annee || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-green-500 focus:outline-none focus:ring-green-500"
          >
            <option value="">Toutes les années</option>
            {years.map(year => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>
        </div>
        
        <div>
          <label htmlFor="membre" className="block text-xs font-medium text-gray-700">
            Membre
          </label>
          <select
            id="membre"
            name="membre"
            value={filters.membre || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-green-500 focus:outline-none focus:ring-green-500"
          >
            <option value="">Tous les membres</option>
            {membres.map(membre => (
              <option key={membre.id_membre} value={membre.id_membre}>
                {membre.nom_prenom_membre}
              </option>
            ))}
          </select>
        </div>
        
        <div>
          <label htmlFor="dateDebut" className="block text-xs font-medium text-gray-700">
            Date début
          </label>
          <input
            type="date"
            id="dateDebut"
            name="dateDebut"
            value={filters.dateDebut || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-green-500 focus:outline-none focus:ring-green-500"
          />
        </div>
        
        <div>
          <label htmlFor="dateFin" className="block text-xs font-medium text-gray-700">
            Date fin
          </label>
          <input
            type="date"
            id="dateFin"
            name="dateFin"
            value={filters.dateFin || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-green-500 focus:outline-none focus:ring-green-500"
          />
        </div>
        
        <div className="grid grid-cols-2 gap-2">
          <div>
            <label htmlFor="montantMin" className="block text-xs font-medium text-gray-700">
              Montant min
            </label>
            <input
              type="number"
              id="montantMin"
              name="montantMin"
              value={filters.montantMin || ""}
              onChange={handleInputChange}
              placeholder="Min"
              className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-green-500 focus:outline-none focus:ring-green-500"
            />
          </div>
          
          <div>
            <label htmlFor="montantMax" className="block text-xs font-medium text-gray-700">
              Montant max
            </label>
            <input
              type="number"
              id="montantMax"
              name="montantMax"
              value={filters.montantMax || ""}
              onChange={handleInputChange}
              placeholder="Max"
              className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-green-500 focus:outline-none focus:ring-green-500"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SosialyFilters;